import { useContext } from 'react';
import LocaleContext from '../context';
export default (() => {
  const contextValue = useContext(LocaleContext);
  return {
    locale: contextValue === null || contextValue === void 0 ? void 0 : contextValue.locale,
    setLocale: contextValue === null || contextValue === void 0 ? void 0 : contextValue.setLocale
  };
});
//# sourceMappingURL=useOnlyLocale.js.map